import React, { useState, useEffect, use } from 'react';
import { Me } from '../api/users';
import { getFoodName, getAllFood, CreateRepastFoods, CreateRepastCombo, GetOpenCombo, GetUserRepastFoodByDate } from '../api/food';
import { getAllFieldsCombo } from '../api/food';
import { getAllFoodFieldsCombo, GetAllSelectedFoodByRepastId } from '../api/food';
import { userShift } from '../api/shift';
import { UserShiftMNG } from '../api/mng_shift';
import { GetRestaurants } from '../api/restaurant';
import { OpentypeShiftGet} from '../api/type_shift';




const RecordCombo = ({ token }) => {
    const [userShifts, setUserShifts] = useState()
    const [userShiftHours, setUserShiftHourt] = useState()

    const [allCombo, setAllCombo] = useState([])
    const [allFieldsCombo, setAllFieldsCombo] = useState([])
    const [allFood, setAllFood] = useState({})
    const [userRepastFood, setUserRepastFood] = useState(null)
    const [selectedCombo, setSelectedCombo] = useState('')
    const [foodCombo, setFoodCombo] = useState({})
    const [selectedFoods, setSelectedFoods] = useState({})
    const [modalMessage, setModalMessage] = useState('')


    const loadAllCombo = async () => {
          try {
            const date = new Date()
            const user = await Me(token)
            const shifts = await userShift(token, user.id, formatDate(date), formatDate(date))
            const mngShifts = await UserShiftMNG(token, user.id, formatDate(date), formatDate(date))
            const restaurants = await GetRestaurants(token, 1, 1)
            let restNames = {}
            for (let rest of restaurants.data){
                restNames[rest.id] = rest.name
            }
            const typeShifts = await OpentypeShiftGet(token)
            let typeShiftNames = {}
            for (let typeshift of typeShifts){
                typeShiftNames[typeshift.id] = typeshift.name
            }
            
            renderUserShifts(shifts)
            renderMNGShifts(mngShifts, restNames, typeShiftNames)

            const userRepastFood = await GetUserRepastFoodByDate(token, {date: formatDate(date),  user_id: user.id})
            
            if (userRepastFood){
                const userFoods = await GetAllSelectedFoodByRepastId(token, userRepastFood.id)
                renderRepastFood(userFoods)
                return
            }

            
            if (shifts.length != 0){

                const allFoodDB = await getAllFood(token)
        
                for (let food of allFoodDB){
                    allFood[food.id] = food.name
                }
                setAllFood(allFood)
                let hours = 0
                for (let shift of shifts){
                    hours += shift.hours
                }
                setUserShiftHourt(hours)
                const openFood = await GetOpenCombo(token)
                setAllCombo(openFood)
            }

            if (mngShifts.length != 0){

                const allFoodDB = await getAllFood(token)
        
                for (let food of allFoodDB){
                    allFood[food.id] = food.name
                }
                setAllFood(allFood)
                let hours = 0
                for (let shift of shifts){
                    hours += shift.hours
                }
                setUserShiftHourt(hours)
                const openFood = await GetOpenCombo(token)
                setAllCombo(openFood)
            }

            
            
            }
              catch (err) {
                console.error(err);
              }
          };
      
    useEffect(() => {
    
        loadAllCombo();
    }, [token]);
    

    
    async function selectCombo(e, comboId) {
        setSelectedCombo(comboId)
        const fields = await getAllFieldsCombo(token, comboId)
        let fieldsCombo = {}
        let fieldsFood = {}
        for (let field in fields) {
            fieldsFood[fields[field].id] = ''
            const foods = await getAllFoodFieldsCombo(token, fields[field].id)
            let foods_now = []
            for (let food in foods) {
                const d = await getFoodName(token, foods[food].food_id)
                foods_now.push(d)
            }

            fieldsCombo[fields[field].id] = foods_now
        }
        setFoodCombo(fieldsCombo)
        setAllFieldsCombo(fields)
        setSelectedFoods(fieldsFood)
    }

    async function selectField(e, fieldId) {
        console.log(fieldId, e.target.value, selectedFoods)
        selectedFoods[fieldId] = e.target.value
        setSelectedFoods(selectedFoods)
    }

    async function recordRepast(e) {
        console.log(selectedFoods)
        for (let field in selectedFoods){
            if (selectedFoods[field] == '' || selectedFoods[field] == '0'){
                setModalMessage(<p style={{color: "red"}}>Выберите еду во всех полях!</p>)
                return
            }
            // console.log()
        }
        const newRepast = await CreateRepastCombo(token, selectedCombo)
        const repastId = newRepast.id
        let repastFoodList= []
        for (let food in selectedFoods){
            repastFoodList.push({"repast_id": repastId, "food_id": selectedFoods[food]})
        }
        const d = await CreateRepastFoods(token, repastFoodList)
        let message = 'Ваш сегодняший прием пищи: ' 
        for (let food of d){
            if (food == d.at(-1)){
                message += allFood[food.food_id] + '.'
                break
            }
            message += allFood[food.food_id] + ', '
        }
        setModalMessage(<p style={{color: "green"}}>{message}</p>)
        setUserRepastFood(message)
    }

    function renderUserShifts(data){
        if (data.length == 0){
            setUserShifts(<p className='text-center'>У вас нет смен</p>)
            return 
        }
        else {
            setUserShifts(
                <div className="profile-table ">
                    <table className="table table-bordered ">
                        <thead>
                            <tr>
                            <th scope="col" className='text-center profile'>Дата</th>
                            <th scope="col" className='text-center profile'>День недели</th>
                            <th scope="col" className='text-center profile'>Время</th>
                            <th scope="col" className='text-center profile'>Станция</th>
                            <th scope="col" className='text-center profile'>Ресторан</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(shift => (
                                <tr className='text-center' key={shift.id}>
                                    <td>{shift.date} </td>
                                    <td>{getRussianWeekday(shift.date)}</td>
                                    <td>{shift.start} - {shift.end}</td>
                                    <td>{shift.station_name}</td>
                                    <td>{shift.restaurant_name}</td>
                                </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            )
            return
        }
    }

    function renderMNGShifts(data, restNames, typeShiftNames){
        if (data.length != 0){
        
            setUserShifts(
                <div className="profile-table ">
                    <table className="table table-bordered ">
                        <thead>
                            <tr>
                            <th scope="col" className='text-center profile'>Дата</th>
                            <th scope="col" className='text-center profile'>День недели</th>
                            <th scope="col" className='text-center profile'>Время</th>
                            <th scope="col" className='text-center profile'>Станция</th>
                            <th scope="col" className='text-center profile'>Ресторан</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(shift => (
                                
                                <tr className='text-center' key={shift.id}>
                                    <td>{shift.date} </td>
                                    <td>{getRussianWeekday(shift.date)}</td>
                                    <td>{shift.start} - {shift.end}</td>
                                    <td>{shift.type_shift_id !== 1 ? typeShiftNames[shift.type_shift_id] : shift.name}</td>
                                    <td>{restNames[shift.restaurant_id]}</td>
                                </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            )
            return
        }
    }

    function renderRepastFood(data){
        let message = 'Ваш сегодняший прием пищи: '
        console.log(data)
        for (let food of data){
            if (food == data.at(-1)){
                message += food.name + '.'
                break
            }
            message += food.name + ', '
        }
        setUserRepastFood(message)
    }
          
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="info text-center" style={{marginTop: "5%", fontWeight: 'bolder', fontSize: '30px'}}>
                        <p>Запись обеда сотрудником</p>
                    </div>
                    {userShifts}
                </div>
                <div className="col-md-4 offset-md-4">
                    <div className="form-select-repast">
                        {!userRepastFood && (
                        <hr></hr>
                    )}
                        {!userRepastFood && (
                            <select className="form-select" defaultValue={0} aria-label="Default select example" onChange={ (e) => selectCombo(e.stopPropagation(), e.target.value) }>
                            <option value="0" >Выберите комбо</option>
                            {allCombo.map(combo => (
                                <option key={combo.id} value={combo.id}>{combo.name}</option>
                            ) ) }
                            
                            </select>
                    
                        ) }
                    
                        {userRepastFood && (userRepastFood)}
                        
                        {!userRepastFood && (
                            allFieldsCombo.map( field => (
                                <div className="food">
                                    <p className='text-center'>{field.name}</p>
                                        <select className="form-select" defaultValue={0} id="inputGroupSelect01" onChange={ (e) => selectField(e, field.id)} style={{marginBottom: "5%"}}>
                                        <option value="0" >Выберите блюдо</option>
                                        {foodCombo[field.id].map(fieldCombo => (
                                            <option key={`food_${fieldCombo.id}`} value={fieldCombo.id}>{fieldCombo.name}</option>
                                        ))}
                                    </select>
                                </div>
                            ))
                        )}
                        {!userRepastFood && (
                            <div className="btn-record-repast text-center">
                                { (allFieldsCombo.length > 0) && (
                                    <button className='btn text-center' type='btn' onClick={recordRepast} data-bs-toggle="modal" data-bs-target="#exampleModal">Записать</button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-center" id="staticBackdropLabel">Информация о записи приема пищи</h5>
                        </div>
                        <div className="modal-body">
                            {modalMessage}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default RecordCombo

function getRussianWeekday(dateString) {
  const days = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return 'Некорректная дата';
  }
  const dayOfWeek = date.getDay();
  return days[dayOfWeek];
}

const formatDate = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };